export default "__VITE_ASSET__sFP5cOAZ__"